.centerVertically {
  height: 100%;
  display: inline-flex !important;
  align-items: center;
}
